export const globalConfig = {
  apiBaseURL: 'https://hdptc.gazelleplatform.com/services/',
  apiMainBaseURL: 'https://hdptc.gazelleplatform.com/services/security',
  apiDatahubBaseURL:
    'https://hdptc.gazelleplatform.com/services/security/api-proxy-service',
  apiDiagnosticBaseURL:
    'https://hdptc.gazelleplatform.com/services/diagnostics',
  apiServicesUrl: 'https://hdptc.gazelleplatform.com/services/api/',
  securityServicesUrl:
    'https://hdptc.gazelleplatform.com/services/security/',
  sharedServicesUrl:
    'https://hdptc.gazelleplatform.com/services/security/',
  apiPublicURL: 'https://api.gazelleplatform.com',
  loginUrl: 'https://hdptc.origohealth.net',
  datahubHost: 'datahub.gazelleplatform.com',
  logoutUrl:
    'https://hdptc.us.auth0.com/v2/logout?client_id=NVjbG01QmCz19hwyv2xvEI4vIEt5K7SF&returnTo=https://www.hdptc.org',
  authUri:
    'https://hdptc.us.auth0.com/authorize?response_type=code&client_id=NVjbG01QmCz19hwyv2xvEI4vIEt5K7SF&redirect_uri=https://hdptc.gazelleplatform.com/callback&scope=openid%20profile%20email&state=S75G5ASAR9SSSS8DSFSSDS53S63S7D5FHS8G89G80YH9RTJUY5GSKGAS2L42UTF5Y36F93F7462U',
  targetUrl: 'https://hdptc.origohealth.net/',
  userinfoUrl: 'https://hdptc.auth0.com/userinfo',
  neoUrl: "https://neo-hdptc.netlify.app",
  dynamoUrl: "https://dynamo-hdptc.netlify.app",
  breezeUrl: "https://breeze-hdptc.netlify.app",
  state:
    'S75G5ASAR9SSSS8DSFSSDS53S63S7D5FHS8G89G80YH9RTJUY5GSKGAS2L42UTF5Y36F93F7462U',
  platformWelcomeMessage: 'Welcome to the digital convergence experience',
  ehxClaimsTopicName: 'gazelle.ehx.claims.queue',
  ehxClaimsServer: 'amqp://192.168.192.6',
  bearerTokenValue:
    'B234A23N4S235A52SD35B34S6Z5K7L56FA87D69L79FK879A6S57F436K2JB42K34JS234FB2S3A423H4JF34B6K45A6S45F7B5K67A5S8J8D68F5H65S76A58F',
  userInfoUrl: 'https://hdptc.us.auth0.com/userinfo',
  developmentUrl: 'http://localhost:3011',
  paginationLimit: 5,
  googleMapsApi: 'AIzaSyCeNLUmMgY8Nw1aYy9jjyswHwrcK5p_dOg',
  auth0: {
    domain: 'hdptc.us.auth0.com',
    clientId: 'NVjbG01QmCz19hwyv2xvEI4vIEt5K7SF',
    managementAPIUrl: 'https://hdptc.us.auth0.com/api/v2/'
  },
  OPENTOK_URL: 'https://tokbox.com/embed/embed/ot-embed.js?',
  MAP_BOX_ACCESS_TOKEN:
    'pk.eyJ1Ijoib3JpZ29zb2Z0d2FyZSIsImEiOiJja2lkZXAyOTUwa2hpMnhwZXphcDEwYnBlIn0.bL_Xsmn35OU6bbpI9o84vQ',
  defaultFacilityId: 3597,
  defaultProviderId: 1,
  twilio: {
	messagingServiceSid : "MGa997dea2e37e42575b9424ac1703b24a",
    contentSid : "HX73fe9a3f5c5e3d820fff0f1a82d4b3de",
    whatsAppChannelNumber : "+18453799458",
	},  
  serviceAccessToken: "fbc693b3-ba2d-41c1-b054-dd8506c5161c:100023",
  cloudName: 'GABP'
}
